import React from 'react';
import ForgotPassword from '../../@jumbo/components/Common/authComponents/ForgotPassword';

const ForgotPasswordPage = () => <ForgotPassword variant="default" wrapperVariant="default" />;

export default ForgotPasswordPage;
